<template>
  <div class="createAcct">
    <navbar></navbar>
    <svgicon icon="design-element" class="design-element"></svgicon>
    <div class="createAcct__wrap forgot-email-sent-container">
      <h6 class="createAcct__title signup__title">We’ve sent you an email</h6>
      <p class="signup__subtitle mb-5">
        Click the link we’ve sent to your email. If you don’t see it, please be
        sure to check your spam folder.
      </p>

      <p v-if="countDown !== 0" class="retry mb-3">
        Retry in {{ countDown }} second(s)
      </p>

      <button
        type="button"
        class="createAcct__ctaBtn"
        :class="{ disabled: countDown !== 0 }"
        @click="submit"
        :disabled="countDown !== 0"
      >
        <svgicon v-if="loading" icon="spinner" class="button__loader"></svgicon>
        Resend Reset Link
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import navbar from "../navbar";
import { forgotPassword } from "../../../../services/dashboard";

export default {
  name: "email-sent",
  components: {
    navbar
  },
  data() {
    return {
      email: JSON.parse(localStorage.getItem("resend-email")) || "",
      loading: false,
      countDown: 20
    };
  },
  destroyed() {
    localStorage.removeItem("resend-email");
  },
  methods: {
    async submit() {
      this.loading = true;

      const port = process.env.PORT || "8082";

      try {
        const body = {
          email: this.email,
          callbackUrl:
            process.env.VUE_APP_DOMAIN === "localhost"
              ? `http://${process.env.VUE_APP_DOMAIN}:${port}/change-password`
              : `https://${process.env.VUE_APP_DOMAIN}/change-password`
        };

        const response = await forgotPassword(body);
        if (response.statusCode === 201) {
          this.countDown = 20;
          this.countDownTimer();
          this.$notification.success({
            message: "Password Reset Sent",
            description: response.message
          });
        }
      } catch (error) {
        return error;
      } finally {
        this.loading = false;
      }
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    }
  },
  created() {
    this.countDownTimer();
  }
};
</script>

<style lang="scss" scoped>
.forgot-email-sent-container {
  max-width: 500px;
  margin: 8rem auto auto auto;
  text-align: center;

  p {
    font-weight: 400;
    font-size: 15px;
  }

  button {
    width: fit-content;
    padding: 0 30px;
  }

  .retry {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/forgot-password/email-sent.vue